var map = {
	"./de.json": [
		"./loc/de.json",
		"loc_de_json"
	],
	"./en.json": [
		"./loc/en.json",
		"loc_en_json"
	],
	"./eo.json": [
		"./loc/eo.json",
		"loc_eo_json"
	],
	"./es.json": [
		"./loc/es.json",
		"loc_es_json"
	],
	"./nl.json": [
		"./loc/nl.json",
		"loc_nl_json"
	],
	"./oc.json": [
		"./loc/oc.json",
		"loc_oc_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./loc lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;